module.exports = __webpack_public_path__ + "img/bg2.2e036645.jpg";